import Icon from "components/ui/Icon";
import React from "react";
import styled from "styled-components";

const StyledSelect = styled.select<{ $hasError?: boolean }>`
  width: 100%;
  height: 48px;
  padding: 0 12px;

  background: white;
  border: 1px solid ${(props) => props.theme.colors.text}40;
  border-radius: 8px;
  outline: 0;
  appearance: none;

  font-family: ${(props) => props.theme.fonts.body};
  font-size: ${(props) => props.theme.fontSizes.sm}px;

  transition: all ${(props) => props.theme.transitions.simple};

  ${(props) =>
    props.$hasError
      ? `
  border-color: ${(props) => props.theme.colors.danger};
  `
      : ""}

  &:focus {
    border-color: ${(props) => props.theme.colors.text};
    box-shadow: ${(props) => props.theme.shadows.regular};
  }

  &:invalid {
    color: ${(props) => props.theme.colors.text}80;
  }
`;

const Wrapper = styled.div`
  position: relative;

  svg {
    position: absolute;
    top: 50%;
    right: 12px;
    transform: translateY(-50%);

    color: ${(props) => props.theme.colors.text}80;
  }
`;

export interface SelectOption {
  name?: string;
  value: string;
  data?: any;
}

export interface SelectProps
  extends React.SelectHTMLAttributes<HTMLSelectElement> {
  value?: any;
  hasError?: boolean;
  options: SelectOption[];
}

const Select: React.ForwardRefRenderFunction<HTMLSelectElement, SelectProps> = (
  { name, onChange, options, hasError, ...props },
  ref
) => (
  <Wrapper>
    <StyledSelect
      name={name}
      onChange={onChange}
      ref={ref}
      $hasError={hasError}
      {...props}
    >
      <option value="" disabled>
        Select one
      </option>
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.name || option.value}
        </option>
      ))}
    </StyledSelect>

    <Icon name="chevronDown" size="sm" />
  </Wrapper>
);

export default React.forwardRef(Select);
